import { Field } from '../../field';
import { Component, OnInit } from '@angular/core';
import { LayoutService } from '@app/layout/layout.service';
import * as moment from 'moment';

@Component({
  selector: 'app-input-cc-validity',
  templateUrl: './input-cc-validity.component.html',
  styleUrls: ['./input-cc-validity.component.less'],
})
export class InputCcValidityComponent extends Field {
  years = [];

  selectedMonth = '';
  selectedYear = '';

  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  ngOnInit(): void {
    for (
      let index = new Date().getFullYear();
      index < new Date().getFullYear() + 50;
      index++
    ) {
      this.years.push(index);
    }

    if (
      this.recordProperty.ValueAsObject == null ||
      this.recordProperty.ValueAsObject === undefined ||
      this.recordProperty.ValueAsObject === ''
    ) {
      this.selectedMonth = '';
      this.selectedYear = '';
    } else {
      let values = moment(
        this.recordProperty.ValueAsObject,
        'YYYY-MM-DDTHH:mm:ss'
      ).toDate();
      this.selectedMonth = (values.getMonth() + 1).toString().padStart(2, '0');
      this.selectedYear = values.getFullYear().toString();
    }
  }

  ccValidityValueChanged() {
    let dateValue = new Date(
      Number(this.selectedYear),
      Number(this.selectedMonth) + 1,
      1
    );
    this.recordProperty.ValueAsObject = moment(dateValue).format('yyyyMMDD');
    this.recordProperty.Value = moment(dateValue).format('yyyyMMDD');
    this.valueChanged();
  }
}
